import { Button } from '@/components/ui/button'

type Pagination = { caption: string; next_cursor: string | null; previous_cursor: string | null }

export function PortalPagination({
  pagination,
  onPage,
}: {
  pagination: Pagination
  onPage: (cursor: string) => void
}) {
  return (
    <div className="flex items-center justify-between gap-2 border-t border-border px-4 py-3">
      <span className="text-caption text-muted-foreground">{pagination.caption}</span>
      <div className="flex gap-2">
        {(['previous', 'next'] as const).map((direction) => {
          const cursor = pagination[`${direction}_cursor`]
          return (
            cursor !== null && (
              <Button key={direction} variant="outline" size="sm" onClick={() => onPage(cursor)}>
                {direction === 'previous' ? 'Previous' : 'Next'}
              </Button>
            )
          )
        })}
      </div>
    </div>
  )
}
